export class EstadoSesion {
    estado: boolean = false;
    poll: string = 'Nulo';
    fechaHoraPoll: string = 'Nulo';
    sesionId: string = 'Nulo';
}

/**
 * Bloqueo es el contenido de "easymed/" + prefijoBase + '/arbitro/bloqueo'
 */
export class Bloqueo {
  elemento: string = ''; // "paciente"
  ceja: string = ''; // "datos"
  id: string = ''; // "20230409_123335_694_410175";
  fechahora: string = ''; // "20231225_221600_159"
  sesion: string = ''; // "20231225_221355_550___ortegalopez@hotmail_com___ZQHuJAibETNjNGNyR3b2hFKhWfz1"
  confirmar: number = 0; // 0 al crear, reclamaBloqueo suma 1 cada vez que alguien pide confirmar
}
